export default __webpack_public_path__ + "d9e6937205598a2065338fd2ff6facd2.ttf";